import { IS_NEW_BACKEND_CLIENT_VERSION, UPDATE_RESULT_STATUS } from 'common/constants';

const initState = {
    resultStatus: '',
    backendClientVersion: '',
    isReloadPage: false,
};

const resultReducer = (state = initState, action) => {
    switch (action.type) {
        case UPDATE_RESULT_STATUS:
            return {
                ...state,
                resultStatus: action.payload
            };
        case IS_NEW_BACKEND_CLIENT_VERSION:
            return {
                ...state,
                isReloadPage: action.payload
            };
        default:
            return state;
    }
};

export default resultReducer;
